import { getApiErrorCode } from './get-api-error-code';

const NOT_FOUND_CODES = new Set(['NOT_FOUND', 'VALIDATION_ERROR']);
const NOT_FOUND_STATUSES = new Set([404, 422]);

/**
 * Whether a rejected read means "there is no such record" (NPJB-750): a 404, or a 422 for
 * an id that is not even the right shape. Both are a bad link, not a failure to retry.
 *
 * Reads the backend's error code as well as the status, because `backend-request`
 * rejects with the unwrapped `{ code, message }` envelope, which carries no status.
 */
export const isNotFoundError = (err: unknown): boolean => {
  const code = getApiErrorCode(err);
  if (code) return NOT_FOUND_CODES.has(code);
  const status = (err as { status?: unknown } | null | undefined)?.status;
  return typeof status === 'number' && NOT_FOUND_STATUSES.has(status);
};
